import { cn } from "@/lib/utils"

interface PriceDisplayProps {
  formattedFinalPrice: string
  formattedRegularPrice: string
  className?: string
  fromPrefix?: string
  /** Accessible label for sale pricing — should be translated by the caller */
  saleAriaLabel?: string
}

export function PriceDisplay({
  formattedFinalPrice,
  formattedRegularPrice,
  className,
  fromPrefix,
  saleAriaLabel,
}: PriceDisplayProps) {
  const isOnSale = formattedRegularPrice !== formattedFinalPrice

  return (
    <div
      className={cn("tabular-nums", className)}
      aria-label={isOnSale ? saleAriaLabel : undefined}
    >
      {fromPrefix && <span className="text-muted-foreground text-xs mr-1">{fromPrefix}</span>}
      {isOnSale ? (
        <>
          <span className="line-through text-muted-foreground">{formattedRegularPrice}</span>{" "}
          <span className="font-semibold text-[var(--color-error)]">{formattedFinalPrice}</span>
        </>
      ) : (
        <span className="font-semibold">{formattedFinalPrice}</span>
      )}
    </div>
  )
}
